export default {
    FETCHED_ALL_PARTNERS: "FETCHED_ALL_PARTNERS",
    FETCH_PARTNER: "FETCH_PARTNER",
    FETCH_PARTNER_BANKS: "FETCH_PARTNER_BANKS",
    FETCHED_ALL_PARTNERS_FACT_PARAMS: "FETCHED_ALL_PARTNERS_FACT_PARAMS",
    FETCH_PARTNER_FACT_PARAM: "FETCH_PARTNER_FACT_PARAM",
}